<template>
  <div class="info-box">
    <div
      class="p-4 flex flex-col overflow-y-auto gap-y-1 border-t flex-1"
      id="printDom"
    >
      <ul class="font-bold text-center text-gray-900 text-xl mt-3">
        {{
          state.meeting?.bill_title
        }}会议采购付款单
      </ul>
      <strong class="text-xs">会议信息</strong>
      <div class="flex gap-x-5 items-center flex-wrap gap-y-2">
        <c_cell title="会议名称">
          <template #default>
            <strong>{{ state.meeting?.name }}</strong>
          </template>
        </c_cell>
        <c_cell title="会议编号" :value="state.meeting?.number" />
        <c_cell
          title="会议时间"
          :value="state.meeting?.start_date + ' ~ ' + state.meeting?.end_date"
        />
        <c_cell title="会议负责人" :value="state.meeting?.belonger_name" />
      </div>
      <strong class="mt-2 text-xs">付款申请</strong>
      <div class="flex gap-x-5 items-center flex-wrap">
        <c_cell title="申请单号">
          <template #default>
            <div class="flex gap-x-2">
              <strong>{{ state.model?.number }}</strong>
              <c_status
                arrName="Office_Expense_Apply_Status"
                :key="state.model?.status"
                :value="state.model?.status"
              />
            </div>
          </template>
        </c_cell>
        <c_cell title="付款金额">
          <template #default>
            <strong class="text-xl">{{
              $priceFormat(state.model?.amount)
            }}</strong>
          </template>
        </c_cell>
        <c_cell title="付款方式" :value="state.model?.d_payment_type_name" />
        <c_cell title="收款信息">
          <template #default>
            <div class="flex gap-x-2" v-if="state.model?.is_supplier_purchase">
              <text>{{ state.model?.supplierBankAccount?.opening_bank }}</text>
              <text class="text-gray-400">{{
                state.model?.supplierBankAccount?.name
              }}</text>
              <text class="text-gray-400">{{
                state.model?.supplierBankAccount?.account
              }}</text>
            </div>
            <div class="flex gap-x-2" v-else>
              <text>{{ state.model?.opening_bank }}</text>
              <text class="text-gray-400">{{
                state.model?.bank_account_name
              }}</text>
              <text class="text-gray-400">{{ state.model?.bank_account }}</text>
            </div>
          </template>
        </c_cell>
        <c_cell title="申请说明" :value="state.model?.intro" />
      </div>
      <strong class="mt-2 text-xs">审批流程</strong>
      <div class="flex gap-x-5 items-center flex-wrap gap-y-2 text-xs">
        <div
          v-for="item in state.flowApproveStepList"
          :key="item"
          class="flex gap-x-2 items-center"
        >
          <strong>{{ item.step_name }}</strong>
          <template v-if="item.status">
            <text>{{ item?.log?.add_admin_name }}</text>
            <text class="text-gray-400">{{
              item?.log?.add_department_name
            }}</text>
            <text class="text-gray-400">{{ item?.log?.create_time }}</text>
          </template>
          <c_cell
            title="说明"
            v-if="item?.log?.msg && item?.log?.status != 4"
            :size="12"
          >
            {{ item?.log?.msg }}
          </c_cell>
        </div>
      </div>
      <strong class="mt-2 text-xs">采购明细</strong>
      <el-card
        v-for="(row, index) in state.list_data"
        :key="row"
        class="mt-1 h-fit !overflow-visible"
        body-style="padding:2px 10px"
        header-class="!p-2"
      >
        <template #header>
          <div>
            <ul class="flex gap-x-5 flex-wrap gap-y-2 text-sm">
              <strong>{{ index + 1 + "." + row.number }}</strong>
              <li class="flex items-center text-gray-400 text-xs gap-x-2">
                <text class="text-sm text-gray-600">
                  {{ row?.add_admin_name }}
                </text>
                <text>{{ row?.add_department_name }}</text>
                <text class="ml-1">{{ row?.create_time }} 创建</text>
              </li>
            </ul>
            <ul class="flex gap-x-5 flex-wrap gap-y-2 mt-2">
              <c_cell title="结算价">
                <c_money
                  :value="row.amount"
                  :prefix="false"
                  :size="14"
                  color="#000"
                />
              </c_cell>
              <c_cell title="已付">
                <c_money
                  :value="row.paid_amount"
                  :prefix="false"
                  :size="14"
                  color="#000"
                />
              </c_cell>
              <c_cell title="应付">
                <c_money
                  :value="row.unpaid_amount"
                  :prefix="false"
                  :size="14"
                  color="#000"
                />
              </c_cell>
              <c_cell title="本次付款" class="flex-1">
                <c_money
                  :value="row.this_amount"
                  :prefix="false"
                  :size="18"
                  color="#000"
                  bold
                />
              </c_cell>
            </ul>
          </div>
        </template>
        <table class="w-full text-xs" cellpadding="6">
          <thead>
            <tr class="text-left bg-gray-100 whitespace-nowrap">
              <th style="width: 12%">所属分会</th>
              <th style="width: 20%">名称</th>
              <th style="width: 15%">规格</th>
              <th style="width: 10%" class="text-center">单价</th>
              <th style="width: 10%" class="text-center">数量</th>
              <th style="width: 10%" class="text-center">合计</th>
              <th>备注</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in row.meetingPurchaseItemData?.list" :key="item">
              <td>{{ item.meetingPlace?.name }}</td>
              <td>{{ "【" + item.d_cost_type_pname + "】" + item.name }}</td>
              <td>{{ item.specification || "-" }}</td>
              <td class="text-center">{{ item.bill_price }}</td>
              <td class="text-center whitespace-nowrap">
                {{ item.bill_count
                }}<text
                  v-if="item.d_measure_unit_name"
                  class="text-gray-400 text-xs"
                  >{{ "/" + item.d_measure_unit_name }}
                </text>
              </td>
              <td class="text-center">{{ item.bill_amount }}</td>
              <td>{{ item.bill_remark || "-" }}</td>
            </tr>
          </tbody>
        </table>
      </el-card>
    </div>
    <div class="submit-box px-2.5">
      <el-button
        v-show="false"
        plain
        :icon="Printer"
        v-print="printObj"
        ref="printBtn"
      >
        打印采购付款单
      </el-button>
      <el-button plain :icon="Printer" @click="onPrint"
        >打印采购付款单</el-button
      >
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { meetingpurchasepaymentapply_search } from "@/http/fukuanshenpi";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const printObj = {
      id: "printDom",
      // 注入打印样式：分页 + 底部页码
      extraHead: `
      <style>
        @media print {
          @page {
            size: A4;   /* A4横向 */
            margin:50mm;
            /* 底部预留页码位置 */
            @bottom-center {
              content: "第" counter(page) "页";
              font-size:12px;
              margin-top:-2mm;
            }
          }
        }
      </style>
    `,
    };
    const printBtn = ref(null);
    const formDom = ref(null);
    const state = reactive({
      model: {
        id: props.id,
      },
      meeting: {},
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      meetingpurchasepaymentapply_search(props.id).then((res) => {
        if (res.status == 200) {
          const { info, meeting, meetingPurchaseList, flowApproveStepList } =
            res.data?.data || {};
          state.model = info;
          state.meeting = meeting;
          state.list_data = meetingPurchaseList;
          state.flowApproveStepList = flowApproveStepList;
        }
      });
    };

    //打印
    const onPrint = () => {
      printBtn.value.$el.click();
    };

    return {
      state,
      props,
      formDom,
      printObj,
      onPrint,
      printBtn,
    };
  },
};
</script>

<style lang="scss" scoped>
.hesuanprint-tab {
  & > table {
    text-align: center;
    width: 100%;

    & > thead {
      & > tr {
        & > th {
          white-space: nowrap;
        }
      }
    }

    & > tbody {
      & > tr {
        border-top: 1px solid #f4f4f4;
      }
    }
  }
}

.hesuanprint-tab2 {
  & > table {
    width: 100%;

    & > thead {
      & > tr {
        & > th:nth-child(2) {
          text-align: left;
        }
        & > th:not(:nth-child(2)) {
          text-align: center;
          white-space: nowrap;
        }
      }
    }

    & > tbody {
      & > tr {
        border-top: 1px solid #f4f4f4;

        & > td:nth-child(2) {
          text-align: left;
        }
        & > td:not(:nth-child(2)) {
          text-align: center;
        }
      }
    }
  }
}
</style>
<style type="scss"></style>
